<template>
  <div class="flex mb-12 quiz-form">
    <div class="w-3/5 content-left-panel">
      <quiz-form-content
        :embedded="false"
        :onClick="saveQuiz"
      />
    </div>
    <div class="w-2/5 pl-10 content-right-panel" sticky-container>
      <div v-sticky sticky-offset="{top: 25}" sticky-z-index="999">
        <div class="flex mb-10 -mx-2" v-if="isEditing">
          <div class="w-1/2 mx-2 modified-date">
            <label class="vs-input--label">Modified on</label>
            <vs-input disabled :value="getCurrentQuiz.modified | dateFormat"></vs-input>
          </div>
          <div class="w-1/2 mx-2 created-date">
            <label class="vs-input--label">Created on</label>
            <vs-input disabled :value="getCurrentQuiz.created | dateFormat"></vs-input>
          </div>
        </div>
        <div class="flex -mx-2 action-buttons">
          <vs-button class="w-full mx-2 save-button" color="primary" icon-pack="feather" @click="saveQuiz">Save</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sticky from 'vue-sticky-directive'
import quizFormContent from './forms/QuizFormContent'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    quizFormContent
  },
  directives: {Sticky},
  async created() {
    if (this.$route && this.$route.params.id) {
      if (this.$route.params.id !== this.getCurrentQuiz.id) {
        this.getQuizToEdit(this.$route.params.id)
      }
    } else {
      this.resetCurrentQuiz()
    }
  },
  computed: {
    ...mapGetters('app', ['getSelectedCompanyName']),
    ...mapGetters('quizzes', ['getCurrentQuiz']),
    isEditing () {
      return this.$route.name === 'edit-quiz'
    }
  },
  methods: {
    ...mapActions('quizzes', ['getQuizAction', 'resetCurrentQuiz', 'saveQuizToApi']),
    async saveQuiz () {
      try {
        this.$vs.loading()
        
        const response = await this.saveQuizToApi()
        if (this.$route.name === 'create-quiz') {
          this.$router.push({name: 'edit-quiz', params: {id: response.id}})
        }

        this.$vs.loading.close()
        this.$vs.notify({
          title: "Success",
          text: 'Quiz saved',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.$vs.loading.close()
        this.showError(error)
      }
    },
    async getQuizToEdit(quizId = '') {
      this.$vs.loading()
      // User will edit
      // action to get the quiz
      await this.getQuizAction({quizId: quizId})
      if (this.getCurrentQuiz.company !== this.getSelectedCompanyName.toLowerCase()) {
        // ToDo: Possible bug, we could still be in create
        this.$router.push({ name: "create-quiz" });
        this.$vs.notify({
          title: "Warning",
          text: 'Quiz you were editing belongs to a different company',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      }
      this.$vs.loading.close()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "create-quiz") {
      this.resetCurrentQuiz();
    }
    if (to.name === 'edit-quiz') {
      this.getQuizToEdit(to.params.id)
    }
    next();
  }
}
</script>
<style lang="scss">
.quiz-form {
  .is-affixed {
    .inner-wrapper-sticky {
      margin-left: 2.5rem;
    }
  }
}

</style>